import { MockReplacementOrderService } from "@/simulation/replacement-order/mock-replacement-order-service";
import type { ReplacementOrderService } from "./replacement-order-service";

// B7 submitReplacementOrder is not built, so there is no HTTP adapter yet and the simulation service is
// the only submit path. When the HTTP adapter lands this grows a simulation|http resolver like
// device-options-service.factory.ts (http default, simulation on a dev host with the scenario param).
export const createReplacementOrderService = (): ReplacementOrderService =>
  new MockReplacementOrderService();
